import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { apiService } from 'services/service';

export const useGetTask = () => {
    const [task, setTask] = useState(null);
    const [pagination, setPagination] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const fetchTask = async () => {
        setIsLoading(true);
        try {
            const response = await apiService.get('/requests/crm/get-task');
            setTask(response?.data?.data);
            setPagination(response?.data?.info);
            return response?.data?.data;
        } catch (error) {
            console.log('Error from task', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchTask();
    }, []);

    return { tasks: task, isLoading, pagination };
};

export const useTaskMutations = () => {
    const [isPending, setIsPending] = useState(false);

    const mutate = async (data) => {
        setIsPending(true);
        try {
            const response = await apiService.post({
                url: '/requests/crm/create-task',
                payload: data,
            });
            return response?.data;
        } catch (error) {
            console.log('Error from creating task', error);
            toast.error('Error creating task');
        } finally {
            setIsPending(false);
        }
    };

    return { mutate, isPending };
};
